export enum ApiRegion {
  AfricaNorth = 'Africa - Northern & Sahara',
  AfricaSafariEastSouthern = 'Africa - Southern & Safari',
  ArcticAntarctica = 'Arctic & Antarctica',
  AsiaEast = 'Asia - East',
  AsiaSouth = 'Asia - South',
  AsiaSoutheast = 'Asia - Southeast',
  AustraliaAndNewZealand = 'Australia & New Zealand',
  Canada = 'Canada',
  CaribbeanEasternSouthern = 'Caribbean - Eastern & Southern',
  CaribbeanWestern = 'Caribbean - Western',
  CentralAmerica = 'Central America',
  EuropeanEastern = 'Europe - Eastern',
  EuropeanMediterranean = 'Europe - Mediterranean',
  EuropeanUKAndIreland = 'Europe - UK & Ireland',
  EuropeanWesternNorthern = 'Europe - Western & Northern',
  Mexico = 'Mexico',
  MiddleEast = 'Middle East',
  SouthAmerica = 'South America',
  SouthPacific = 'South Pacific',
  Unknown = 'Unknown',
  Alaska = 'USA - Alaska',
  Hawaii = 'USA - Hawaii',
  USAMainland = 'USA - Mainland',
}

export enum Region {
  AfricaNorth = 'North Africa',
  AfricaSafariEastSouthern = 'East & Southern Africa Safari',
  ArcticAntarctica = 'Arctic & Antarctica',
  AsiaEast = 'East Asia',
  AsiaSouth = 'South Asia',
  AsiaSoutheast = 'Southeast Asia',
  AustraliaAndNewZealand = 'Australia & New Zealand',
  Canada = 'Canada',
  CaribbeanEasternSouthern = 'Caribbean - Eastern & Southern',
  CaribbeanWestern = 'Caribbean - Western',
  CentralAmerica = 'Central America',
  EuropeanEastern = 'Eastern Europe',
  EuropeanMediterranean = 'Southern Europe & Mediterranean',
  EuropeanUKAndIreland = 'UK & Ireland',
  EuropeanWesternNorthern = 'Western & Northern Europe',
  Mexico = 'Mexico',
  MiddleEast = 'Middle East',
  SouthAmerica = 'South America',
  SouthPacific = 'South Pacific',
  Unknown = 'Other',
  Alaska = 'Alaska',
  Hawaii = 'Hawaii',
  USAMainland = 'Mainland U.S.',
}
